import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { useNavigate } from 'react-router-dom'
import KeycloakService from '../../../utils/keycloakService'
import { PATIENTS_WRITE } from '../../../utils/roles'
import SelectableSearch from '../../../components/SelectableSearch'
import {
  fetchPatientsAsync,
  selectPatientsActive,
  setPatientSearchQueryValue,
  setPatientStatusActive,
  setRedirectTo,
} from '../patientsSlice'
import { create } from '../../Radiology/Constants/constants'
import {
  bulkRegistrationKey,
  bulkRegistrationValue,
  getallRegType,
  registrationType,
  RegistrationType,
  registrationTypeKey,
  resetKey,
} from '../constants'
import { useEffect, useState } from 'react'
import { startSxpProxy } from '../../../utils/api'
import { REGISTRATION_PROJECT_ID } from '../../../utils/constants'
import { registration } from '../../bedManagement/endpoints/EndPoints'
import DropdownMenu from '../../../components/DropdownMenu/DropdownMenu'
import { formmattedPatientList } from '../utils'
import { exportExcel } from '../../../utils/hooks/Utils'
import { toast } from 'react-toastify'
import { dropDownMenuKeys, noDataMessage } from '../../../components/constants'

const PatientSearch = ({
  onSelect,
  selectedPatientId,
}: {
  onSelect: (e: any[]) => void
  selectedPatientId: null | string | number
}) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const patients = useAppSelector((state) => state.patients?.data)
  const [selectedType, setSelectedType] = useState<any[]>([])
  const [regType, setSelectedRegType] = useState<string>('')
  const patientsActive = useAppSelector(selectPatientsActive)
  const handleSearch = (query: any, param: string) => {
    let q = ''
    switch (query) {
      case 'ID':
        q = 'identifier'
        break
      case 'Phone':
        q = 'phone'
        break
      case 'Name':
        q = 'name'
        break
    }
    dispatch(setPatientSearchQueryValue({ query: q, value: param }))
    dispatch(fetchPatientsAsync())
  }

  const registerPatient = () => {
    if (KeycloakService.hasRole([PATIENTS_WRITE])) {
      dispatch(setRedirectTo('patients'))
      navigate(registration)
    }
  }
  const getRegistrationType = async () => {
    try {
      const intent = getallRegType
      const resp = await startSxpProxy(REGISTRATION_PROJECT_ID, intent)

      if (resp?.data?.fhir_registration_types) {
        setSelectedType(resp?.data?.fhir_registration_types)
      }
    } catch (e) {
      console.error(e)
    }
  }
  useEffect(() => {
    getRegistrationType()
  }, [])
  const registrationOptions = selectedType?.map((type) => {
    return {
      label: type?.name,
      value: type?.value,
      resetGroup: 'registration',
    }
  })
  const handleRegTypeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = event.target.value
    setSelectedRegType(selectedValue)
    handleSearch('ID', selectedValue)
  }
  const handleDownload = () => {
    const patientList = formmattedPatientList(patients)
    if (patientList?.length === 0) {
      toast?.error(noDataMessage)
    } else {
      exportExcel(patientList)
    }
  }
  const handleSelect = (s: any[]) => {
    onSelect(s)
    if (
      s?.[0] === dropDownMenuKeys?.active ||
      s?.[0] === dropDownMenuKeys?.inActive
    ) {
      dispatch(setPatientStatusActive(s?.[0] === dropDownMenuKeys?.active))
      dispatch(fetchPatientsAsync())
    }
    if (s?.[0] === dropDownMenuKeys?.export) {
      handleDownload()
    }
    if (s?.[0] === registrationType) {
      setSelectedRegType(s?.[1])
      if (s?.[1] === '') {
        handleSearch('', '')
      } else {
        handleSearch('ID', s?.[1])
      }
    }
  }
  return (
    <div className='patient-filter'>
      <div className='patient-search'>
        <div>
          <select value={regType} onChange={handleRegTypeChange}>
            <option value=''>{RegistrationType}</option>
            {selectedType?.map((type) => (
              <option key={type?.id} value={type?.value}>
                {type?.name}
              </option>
            ))}
          </select>
        </div>

        <DropdownMenu
          onSelect={handleSelect}
          filterOptions={[
            {
              label: dropDownMenuKeys?.activeKey,
              value: dropDownMenuKeys?.active,
              active: patientsActive,
            },
            {
              label: dropDownMenuKeys?.inActiveKey,
              value: dropDownMenuKeys?.inActive,
              active: !patientsActive,
            },
            {
              label: registrationTypeKey,
              value: registrationType,
              subOptions: [
                ...registrationOptions,
                { label: resetKey, value: '' },
              ],
            },
          ]}
          actionOptions={[
            {
              label: dropDownMenuKeys?.exportKey,
              value: dropDownMenuKeys?.export,
            },
            {
              label: dropDownMenuKeys?.deleteKey,
              value: dropDownMenuKeys?.delete,
              disabled: !selectedPatientId ? true : false,
            },
            {
              label: dropDownMenuKeys?.archiveKey,
              value: dropDownMenuKeys?.archive,
              disabled: !selectedPatientId ? true : false,
            },
            {
              label: bulkRegistrationKey,
              value: bulkRegistrationValue,
            },
          ]}
          selectedId={selectedPatientId ? true : false}
          filterApply={!patientsActive || regType !== ''}
          showFilter
          showAction
        />
        <SelectableSearch
          items={['ID', 'Phone', 'Name']}
          onSearch={handleSearch}
        />
        <button
          className={`btn btn-primaryBtn ml10 ${
            KeycloakService.hasRole([PATIENTS_WRITE]) ? '' : 'auth-disabled'
          }`}
          onClick={registerPatient}
        >
          {create}
        </button>
      </div>
    </div>
  )
}

export default PatientSearch
